const Header = () => (
  <div className="flex flex-col items-center text-center">
    <h1
      id="upgrade-plan-title"
      className="text-xl font-bold tracking-tight sm:text-[22px]"
      style={{ color: '#fff', lineHeight: 1.2 }}
    >
      Escolha seu pacote de vantagens
    </h1>
    <p
      className="mt-1.5 max-w-sm text-[13px]"
      style={{ color: 'rgba(255,255,255,0.45)', lineHeight: 1.5 }}
    >
      Encontre o plano ideal para o crescimento da sua operação.
    </p>
  </div>
)

export default Header
